import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { shape, arrayOf, string } from 'prop-types';
import { usePublisher } from '@magalu/mixer-publisher';
import withLayoutProps from '../../../hocs/withLayoutProps';
import ShareLinksActions from './components/ShareLinksActions';
import ShareLinksProduct from './components/ShareLinksProduct';
import { useScrollLock } from './hooks/useScrollLock';
import { CloseButton, CloseButtonIcon, Container, Content, ShareContainer, ShareOverlay } from './ShareLinks.styles';
var ShareLinks = function ShareLinks(props) {
  var data = props.data,
    staticProps = props["static"],
    structure = props.structure;
  var _staticProps$device = staticProps.device,
    device = _staticProps$device === void 0 ? 'desktop' : _staticProps$device;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShareActive = _useState2[0],
    setIsShareActive = _useState2[1];
  var _usePublisher = usePublisher(),
    subscribe = _usePublisher.subscribe;
  useScrollLock(device, isShareActive);
  var onCloseShareActive = function onCloseShareActive() {
    setIsShareActive(false);
  };
  useEffect(function () {
    subscribe('sharelinksbutton:click', function () {
      return setIsShareActive(true);
    });
  }, []);
  return React.createElement(ShareContainer, {
    "data-testid": "share-links"
  }, React.createElement(Container, {
    active: isShareActive,
    device: device,
    "data-testid": "share-links-content"
  }, React.createElement(CloseButton, {
    "data-testid": "btn-close-modal",
    name: "Close",
    onClick: onCloseShareActive,
    color: "none",
    "aria-label": "fechar o modal"
  }, React.createElement(CloseButtonIcon, {
    name: "Close"
  })), React.createElement(Content, null, React.createElement(ShareLinksProduct, {
    data: data,
    device: device
  }), React.createElement(ShareLinksActions, _extends({
    active: isShareActive,
    data: data,
    structure: structure
  }, staticProps)))), React.createElement(ShareOverlay, {
    "data-testid": "share-links-overlay",
    device: device,
    active: isShareActive,
    onClick: onCloseShareActive
  }));
};
process.env.NODE_ENV !== "production" ? ShareLinks.propTypes = {
  data: shape({
    product: shape({
      image: string,
      title: string
    })
  }),
  "static": shape({
    device: string,
    sectionSharedBag: shape({
      buttonLabel: string,
      show: string,
      url: string
    }),
    sectionSocial: shape({
      buttons: arrayOf(shape({
        color: string,
        eventType: string,
        href: string,
        name: string
      })),
      title: string
    })
  }),
  structure: shape({})
} : void 0;
ShareLinks.defaultProps = {
  data: {},
  "static": {
    device: 'desktop',
    sectionSharedBag: {
      buttonLabel: 'Adicionar à Sacola Pronta',
      show: 'false',
      url: '#'
    },
    sectionSocial: {
      title: 'Compartilhe nas redes sociais'
    }
  },
  structure: {}
};
ShareLinks.ssr = false;
ShareLinks.displayName = 'ShareLinks';
ShareLinks.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
export default withLayoutProps(ShareLinks);